var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"xs":"12","lg":"6"}},[_c('section',{attrs:{"id":"firebaseui-auth-container"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }